// extracted by mini-css-extract-plugin
export var inlineLink = "_8a-0";
export var inlineLinkButton = "_8a-1";